export default __webpack_public_path__ + "static/media/1.b6c3e126.svg";